export default __webpack_public_path__ + "media/zurb/img/home/home-process-img2-d939166d0cbe08f84e8aa316eb1e624f.png";